<template>
  <div class="text-xs-center">
    <v-dialog v-model="controlDialogVisible" scrollable :fullscreen="fullscreen" :max-width="width" :persistent="!closeWithMask">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Editar Chamado #{{ dataValue.called_id ? dataValue.called_id : dataValue.id }}
        </v-card-title>

        <v-card-text>
          <v-layout row>
            <v-flex xs12 md3>
              <v-subheader class="pl-0 date-label">{{ $t('views.fields.called.date') }}</v-subheader>
              <date-picker
                placeholder="Selecione a data"
                v-model="date"
                :lang="lang"
                :editable="false"
                format="DD/MM/YYYY"
                value-type="format"
                clearable></date-picker>
            </v-flex>
          </v-layout>
          <v-layout row mt-3>
            <v-flex xs12 md9 pr-1>
              <v-text-field label="Titulo do Chamado" v-model="dataValue.title" :counter="100" disabled>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md3 v-if="dataValue.cycle && dataValue.cycle.active === 'sim'">
              <v-text-field
                :mask="'time'"
                v-model="worked_hours"
                label="Horas Trabalhadas"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6 pr-1>
              <v-select
                :items="priorities"
                v-model="priorityId"
                item-text="description"
                item-value="id"
                required
                hint="Vincular uma prioridade a este chamado"
                label="Selecione a prioridade"
                persistent-hint
                :disabled="priorities.length === 0"></v-select>
            </v-flex>
            <v-flex xs12 md6 pl-1>
              <v-select
                :items="calledStatus"
                v-model="calledStatusId"
                item-text="description"
                item-value="id"
                required
                hint="Vincular um status para este chamado"
                label="Selecione o status"
                persistent-hint
                :disabled="calledStatus.length === 0"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-4">
            <v-flex xs12 md12>
              <v-autocomplete
                label="Vincular Chamado"
                v-model="linkedSelected"
                :loading="loadingCalled"
                :items="listCalled"
                :filter="customCalledListFilter"
                item-text="title"
                hide-selected
                return-object
                :search-input.sync="searchTerm"
                no-data-text="Nenhuma registro encontrado"
                hint="Informe acima o número do chamado"
                persistent-hint
                @change="onSelectedLinked"
              >
                <template slot="selection" slot-scope="props">
                  <v-chip
                    :selected="props.selected"
                    close
                    class="chip--select-multi">
                    #{{ props.item.id }} - {{ props.item.title }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      #{{ props.item.id }} - {{ props.item.title }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      Ciclo: {{ props.item.cycle.name }} / Status: {{ cycleStatus[props.item.cycle.active] }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="dataValue.linked && dataValue.linked.length > 0" mt-3>
            <v-flex xs12 class="data-called-linked">
              <strong>Chamados Vinculados:</strong>
            </v-flex>
            <v-flex xs12 class="data-called-linked">
              <v-data-table
                :key="`linked_${updatedLinked}`"
                :headers="headersLinked"
                :items="dataValue.linked"
                :total-items="dataValue.linked.length"
                :hide-actions="true"
                class="elevation-0">

                <template slot="items" slot-scope="props">
                  <td>
                    #{{ props.item.id }}
                  </td>
                  <td>
                    {{ props.item.title }}
                  </td>
                  <td>
                    {{ props.item.project.name }}
                  </td>
                  <td>
                    {{ props.item.priority.description }}
                  </td>
                  <td>
                    {{ props.item.cycle.name }}
                  </td>
                  <td>
                    {{ props.item.called_status.description }}
                  </td>
                  <td class="text-xs-center">
                    <v-tooltip top>
                      <template slot="activator">
                        <v-btn color="primary" flat icon @click="removeLink(props.item.id)">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover Vínculo</span>
                    </v-tooltip>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout row wrap mt-2>
            <v-flex xs12 md6>
              <v-text-field
                v-model="panelLink"
                label="Link do Painel"
                hint="Caso seja um painel, adicione aqui o link"
                persistent-hint
                :rules="validURL"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap mt-4>
            <v-flex xs12>
              <quill-editor ref="description"
                v-model="description"
                :options="editorOption">
              </quill-editor>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="mt-4">
            <v-flex xs12 md12>
              <v-card>
                <v-card-title>
                  <v-checkbox
                    v-model="isMonitor"
                    label="Monitorar"
                    hide-details
                    class="mt-0 pt-0"
                  />
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="monitor"
                    :disabled="!isMonitor"
                    label="Email/WhatsApp"
                    clearable
                    density="compact"
                    placeholder="Digite aqui o email ou whatsapp"
                    hint="Digite um email ou celular válido. (ex.: meuemail@domain.com ou 71988990101)"
                    persistent-hint
                  />
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click.native="addMonitorInList()"
                  >ADD</v-btn>
                </v-card-title>
                <v-data-table
                  v-if="isMonitor"
                  :items="monitors"
                  :headers="[
                {
                  text: 'Email/WhatsApp',
                  sortable: false,
                  align: 'left',
                },
                {
                  text: 'Ação',
                  sortable: false,
                  align: 'right',
                },
              ]"
                  hide-actions
                  no-data-text="Nenhum arquivo anexado."
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item }}</td>
                    <td class="text-md-right">
                      <v-btn icon class="mx-0" @click="deleteMonitorInList({ monitor: props.item })">
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="mt-4">
            <v-flex xs12 md12>
              <v-card>
                <v-card-title>
                  Anexos
                  <v-spacer></v-spacer>
                  <input
                    multiple
                    ref="files"
                    name="file"
                    type="file"
                    class="input-file"
                    @change="handleFileUploads()"/>
                  <v-btn slot="activator" color="primary" dark class="mb-2" @click.native="openBrowserAddFile">Anexar Arquivo</v-btn>
                </v-card-title>
                <v-data-table
                  :items="fileList"
                  :headers="headers"
                  hide-actions
                  no-data-text="Nenhum dado foi adicionado."
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ getExtension(props.item.name) }}</td>
                    <td>{{ props.item.size | convertToByte }}</td>
                    <td class="text-md-center">
                      <v-btn icon class="mx-0" @click="deleteFileInList(props.item)">
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeDialog()">
            Cancelar
          </v-btn>
          <v-btn color="primary" flat @click="saveOrUpdateHistory()">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { padStart as _padStart } from 'lodash';
import DialogMixin from '@/components/mixins/DialogMixin';
import DatePicker from 'vue2-datepicker';
import CalledService from '@/features/called/CalledService';
import PriorityService from '@/features/priority/PriorityService';
import CalledStatusService from '@/features/called-status/CalledStatusService';
import CallHistoryService from '@/features/call-histories/CallHistoryService';

export default {
  name: 'edit-called-dialog',
  mixins: [DialogMixin],
  components: { DatePicker },
  props: {
    dataValue: {
      required: true,
    },
  },
  data() {
    return {
      lang: 'pt-br',
      isMonitor: false,
      monitor: null,
      monitors: [],
      headers: [
        {
          text: 'Nome',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Formato',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Tamanho',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Ação',
          sortable: false,
          align: 'center',
        },
      ],
      headersLinked: [
        {
          text: this.$t('attributes.called.number'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.title'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.project'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.priority'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.cycle'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.status'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
      fileList: [],
      description: '',
      worked_hours: null,
      date: new Date(),
      priorityId: null,
      calledStatusId: null,
      editorOption: {
        placeholder: 'Descrição do chamado...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['link', 'video'],
          ],
        },
      },
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo',
      },
      validURL: [(value) => {
        if (value && value !== '') {
          const pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
          return pattern.test(value) || 'O link informado é inválido';
        }
        return true;
      }],
      priorities: [],
      calledStatus: [],
      linked: null,
      listCalled: [],
      linkedSelected: null,
      loadingCalled: false,
      searchTerm: null,
      updatedLinked: 0,
      panelLink: null,
      calledService: new CalledService(),
      priorityService: new PriorityService(),
      calledStatusService: new CalledStatusService(),
      callHistoryService: new CallHistoryService(),
    };
  },
  watch: {
    async searchTerm() {
      if (this.searchTerm && this.searchTerm !== '') {
        await this.loadCalledListBySearchTerm();
      }
    },
  },
  beforeMount() {
    if (this.dataValue.after_called_status) {
      this.calledStatusId = this.dataValue.after_called_status.id;
    } else if (this.dataValue.called_status) {
      this.calledStatusId = this.dataValue.called_status.id;
    }
  },
  mounted() {
    this.description = this.dataValue.called_id ? this.dataValue.description : '';
  },
  created() {
    this.fillData();
    this.loadPriorities();
    this.loadCalledStatus();
  },
  methods: {
    async loadPriorities() {
      this.priorities = await this.priorityService.query();
    },
    async loadCalledStatus() {
      this.calledStatus = await this.calledStatusService.query();
    },
    openBrowserAddFile() {
      this.$refs.files.click();
    },
    handleFileUploads() {
      this.fileList = [...this.fileList, ...this.$refs.files.files];
      this.reset();
    },
    deleteFileInList(file) {
      const index = this.fileList.indexOf(file);
      this.$dialog.confirm({ title: 'Atenção', content: `Deseja remover o arquivo ${file.name}?` })
        .then((response) => {
          if (response.action === 'ok') {
            this.fileList.splice(index, 1);
            this.$toast.success(this.$t('messages.removeSuccess'));
          }
        });
    },
    reset() {
      const input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';
    },
    saveOrUpdateHistory() {
      const requestOptions = { headers: { 'Content-Type': 'multipart/form-data' } };
      const formData = new FormData();
      if (this.dataValue.called_id) {
        formData.append('called_id', this.dataValue.called_id);
      } else {
        formData.append('called_id', this.dataValue.id);
      }
      formData.append('title', this.dataValue.title);
      formData.append('date', this.date);
      if (this.worked_hours) formData.append('worked_hours', this.worked_hours);
      if (this.description) formData.append('description', this.description);
      if (this.dataValue.called_id) formData.append('id', this.dataValue.id);
      if (this.panelLink && this.panelLink !== '') {
        formData.append('panel_link', this.panelLink);
      }
      formData.append('called_status_id', this.calledStatusId);
      formData.append('priority_id', this.priorityId);
      if (this.dataValue.linked && this.dataValue.linked.length) {
        const allLinked = this.dataValue.linked.map(item => item.id);
        allLinked.forEach((item, index) => {
          formData.append(`linked[${index}]`, item);
        });
      }
      if (this.fileList && this.fileList.length) {
        this.fileList.forEach((file, index) => {
          formData.append(`attachments[${index}]`, file);
        });
      }

      if (this.isMonitor && this.monitors.length > 0) {
        formData.append('monitors', this.monitors);
      }

      if (this.dataValue.called_id) {
        this.updateHistory(formData, requestOptions);
      } else {
        this.saveHistory(formData, requestOptions);
      }
    },
    saveHistory(formData, requestOptions) {
      this.reqSaveConfig = requestOptions;
      this.callHistoryService.save(formData).then()
        .finally(() => {
          this.closeDialog();
          this.$toast.success(this.$t('messages.operationSuccess'));
        });
    },
    updateHistory(formData, requestOptions) {
      this.callHistoryService.request('POST', 'update-call-history', formData, requestOptions).then()
        .finally(() => {
          this.closeDialog();
          this.$toast.success(this.$t('messages.operationSuccess'));
        });
    },
    getExtension(filename) {
      if (filename) {
        const split = filename.split('.');
        return (split[split.length - 1]).toUpperCase();
      }
      return '';
    },
    fillData() {
      this.worked_hours = this.convertMinutesToHours(this.dataValue.worked_hours);
      if (this.dataValue.date) this.date = this.dataValue.date;
      this.calledStatusId = parseInt(this.dataValue.called_status_id, 10);
      if (this.dataValue.after_called_status) {
        this.calledStatusId = parseInt(this.dataValue.after_called_status.id, 10);
      }
      this.priorityId = parseInt(this.dataValue.priority_id, 10);
      if (this.dataValue.after_priority) {
        this.priorityId = parseInt(this.dataValue.after_priority.id, 10);
      }
      this.panelLink = this.dataValue.panel_link;

      if (this.dataValue.monitors && this.dataValue.monitors.length > 0) {
        this.monitors = this.dataValue.monitors.map(item => item.target);
        this.isMonitor = true;
      }
    },
    convertMinutesToHours(time) {
      if (!time || time < 1) {
        return null;
      }
      const hours = Math.floor(time / 60);
      const minutes = (time % 60);
      return `${_padStart(hours, 2, '0')}${_padStart(minutes, 2, '0')}`;
    },
    customCalledListFilter(item, queryText) {
      const textOne = item.title.toLowerCase();
      const textTwo = item.description.toLowerCase();
      const textThree = `${item.id}`;
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1
        || textTwo.indexOf(searchText) > -1
        || textThree.indexOf(searchText) > -1;
    },
    async loadCalledListBySearchTerm() {
      try {
        this.loadingCalled = true;
        this.listCalled = await this.calledService.query({
          term: this.searchTerm,
          notIn: [
            this.dataValue.called_id ? this.dataValue.called_id : this.dataValue.id,
            ...this.dataValue.linked.map(item => item.id),
          ],
        });
        this.loadingCalled = false;
      } catch (e) {
        this.$log.error(e);
        this.loadingCalled = false;
      }
    },
    removeLink(linkedId) {
      const indexOf = this.dataValue.linked.findIndex(item => item.id === linkedId);
      this.dataValue.linked.splice(indexOf, 1);
      this.updatedLinked += 1;
    },
    onSelectedLinked(selected) {
      if (!this.dataValue.linked) {
        this.dataValue.linked = [selected];
      } else {
        this.dataValue.linked.push(selected);
      }
      this.listCalled = [];
      this.linkedSelected = null;
    },
    deleteMonitorInList({ monitor }) {
      this.monitors = this.monitors.filter(item => item !== monitor);
    },
    addMonitorInList() {
      if (this.isMonitor && this.monitor && this.monitor !== '') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phonePattern = /^\d{2}\s?\d{4,5}\d{4}$/;

        if (emailPattern.test(this.monitor) || phonePattern.test(this.monitor)) {
          this.monitors.push(this.monitor);
          this.monitor = null;
        } else {
          this.$toast.error('O email ou número de whatsapp informado é inválido.');
        }
      }
    },
  },
};
</script>
<style>
  .input-file {
    display: none;
  }
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 15rem !important;
    padding-bottom: 1rem;
  }
  .date-label {
    height: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/features/follow-called/EditCalledDialog.vue